<!-- 切换题库 -->
<template>
<van-popup v-model="show" class="change-exam-popup list-popup" position="left" :overlay-style="{background: 'rgba(0, 0, 0, 0.7)'}">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">切换题库</div>
    </div>
    <div class="change-exam-content">
        <div class="exam-item" @click="handleChangeExam(item)" :class="{active: item.examcode === examcode}" v-for="(item) in examList" :key="item.examcode">{{ item.examname }}</div>
    </div>
</van-popup>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            examList: [
                {examname: '基金从业资格', examcode: 'jjcy'},
                {examname: '证券从业资格', examcode: 'zqcy'},
                {examname: '期货从业资格', examcode: 'qhcy'}
            ],
            currentTreeIndex: 0,
            currentSubjectCode: '',
            examcode: 'jjcy'
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.examcode) {
            this.examcode = this.$route.query.examcode
        } else if (this.$route.params.examcode) {
            this.examcode = this.$route.params.examcode
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.show = true
        },
        handleClose() {
            this.show = false
        },
        handleChangeExam(examitem) {
            if (this.examcode !== examitem.examcode) {
                if (this.$route.name === 'MSpecialTopic') {
                    window.location.href = location.origin + '/m/specialTopic/' + examitem.examcode + '/topic'
                } else if (this.$route.name === 'MSpecialChoose') {
                    window.location.href = location.origin + '/m/index?examcode=' + examitem.examcode
                }
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.change-exam-popup {
    width: 5.4rem;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .change-exam-content {
		height: calc(100% - 0.88rem);
        background: #fff;
		padding: 0.4rem 0.3rem 0 0.5rem;
        box-sizing: border-box;
        .exam-item {
            width: 4.6rem;
            height: 0.8rem;
            margin-bottom: 0.4rem;
            border-radius: 0.5rem 0 0.5rem 0;
            text-align: center;
            line-height: 0.8rem;
            font-size: 0.32rem;
            color: #333333;
            background: #F3F5F7;
            &.active {
                background: url('../../../../../common/images/mSpecialTopic/change_exam_bg.png');
                background-size: 100% 100%;
            }
        }
	}
}
</style>